<template>
  <v-dialog
    v-model="showCookiesDialog"
    :fullscreen="showCookiesSettings && $vuetify.breakpoint.smAndDown"
    :max-width="showCookiesSettings ? 800 : $vuetify.breakpoint.width >= 768 ? 656 : 320"
    :width="showCookiesSettings ? 800 : '100%'"
    persistent
    transition="dialog-bottom-transition"
    scrollable
  >
    <CookiesConsentBasic v-if="!showCookiesSettings" />
    <CookiesConsentSettings v-else />
  </v-dialog>
</template>

<script>
import cookiesConsent from '@/mixins/cookiesConsent';
import CookiesConsentBasic from '@/components/Molecules/CookiesConsentBasic';
import UlDialog from '@/components/Atoms/UlDialog';
import CollapseList from '@/components/Molecules/CollapseList';
import InfoMessage from '@/components/Atoms/InfoMessage';
import CookiesConsentSettings from '@/components/Molecules/CookiesConsentSettings';

export default {
  name: 'CookiesDialog',
  components: {
    CookiesConsentSettings,
    InfoMessage,
    CollapseList,
    UlDialog,
    CookiesConsentBasic
  },
  mixins: [cookiesConsent]
};
</script>
